import React, { useState, useEffect } from "react";
import { useParams,  useHistory  } from "react-router-dom";
import { useJwt } from "react-jwt";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from "axios";
import { API_BASE_URL } from "../utils/constants";
import FirstConnectToQbo from "../Components/Onboarding/FirstConnectToQbo";
import http from "../api/client";
import { openNotification } from "../utils/helpers";
 
const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJuYW1lIjoiWmVlc2hhbiIsImFnZSI6MjQsImlhdCI6MTY1MDAwMTc0MiwiZXhwIjoxNjUwMDAxODYyfQ.0vkpDWR4bk_Z-I_zyTmjnqS7tjI1izcv-95owLf_9hY";

  


function Temp() {
  let history = useHistory();
  const [redirect, setRedirect] = useState(false);
  const [step, setStep] = useState(0);
  const [companyDetails, setCompanyDetails] = useState();
  const [compId, setCompId] = useState();
 
  const params = useParams();

  // console.log("UserStatusInState", UserStatusInState);
  // console.log("Params", params);

  const { decodedToken, isExpired } = useJwt(params.token);
  // console.log("Decode Token in Temp", decodedToken);
  
  // as we were facing shopify return url limitation of 250 char we decided not to expire token
  // follow same steps in App.js line line 43
  // const tokenStatus = isExpired;
  const tokenStatus = false;
  

  useEffect(()=>{
    if (decodedToken) {
      setCompId(decodedToken.comp_id)

      if (tokenStatus == false) {
        console.log("token is Valid and  isExpired:", tokenStatus);
        localStorage.setItem('User', JSON.stringify({isValidUser:true, comp_id: decodedToken.comp_id, storeName: decodedToken.shop , token:params.token}));
         apiCallToGetCompanySettings(decodedToken.comp_id);
           
        
      }
      if (tokenStatus == true) {
        console.log("token is not Valid and isExpired:", tokenStatus);
        localStorage.setItem('User', JSON.stringify({isValidUser:false, comp_id:decodedToken.comp_id, storeName: decodedToken.shop , token:params.token}));
        history.push("/unAuthorizedUser");
      }
    }
    
  },[decodedToken]);
 
  async function apiCallToGetCompanySettings(companyId) {
    const companyDetails = await http
      .get("/api/company/details?companyId=" + companyId)
      .then((res) => {
        
        if(res.data && res.status === 200)
        return res.data.data;
      })
      .catch((err) => {
        if(err.response ){
          if(err.response.status === 401 ){
            // console.log("unauthorized in welcome: ",err.response.data.message);
            openNotification(
              "topRight",
              "Unauthorized!",
              err.response.data.message,
              "error"
            );
            history.push("/unAuthorizedUser");
          }
          console.log("Error: Something went wrong!")
        }
         
      });
      if(companyDetails){
        setCompanyDetails(companyDetails);
        // console.log("Company details in Welcome", companyDetails );
      }

      if(companyDetails){
        if(companyDetails.onboarding_status ==  'pending'){
          console.log("inside pending");
          setStep(1);
        } 
        if(companyDetails.onboarding_status ==  'in_progress'){
          console.log("inside in-progress");
          history.push("/onboarding");
        }
        if(companyDetails.onboarding_status ==  'complete'){
          history.push("/"+decodedToken.comp_id);
        }
      }
      

       
  }
 

  function renderSwitch(step) {
    switch(step) {
      case 1:
        return <FirstConnectToQbo compId={compId}/>
        default: return;
    }
  }

  return (
    <div
      className="
    flex
    items-center
    justify-center
    h-screen"
    >
      <div className="bg-white rounded-md shadow-xl w-full">
        <div className="flex flex-col items-center h-screen">
          {renderSwitch(step)}
        </div>
      </div>
    </div>
  );
}

export default Temp;
